/* tslint:disable */
import { Link } from 'gatsby';
import React from 'react';

export const SEO = {
  description: `
    We built Kindur for one goal: to help Baby Boomers make sure their savings outlive their bucket list.
    Start using our Free tools today to learn how.
    `,
  image: `/images/home/prod-shot_hp-hero-income.jpg`,
  title: `Kindur: Retirement Planning, Tools and Investments–Built for Boomers`,
  url: `https://www.kindur.com/`
};

export const Hero = {
  title: (
    <React.Fragment>
      Retirement Planning Tool for <span>Boomers</span>
    </React.Fragment>
  ),
  subtitle: `
    We built Kindur for one goal: to help baby boomers make
    sure their savings outlive their bucket list.
  `,
  bullets: [
    <React.Fragment>
      <b>FREE</b>, easy-to-use planners and tools
    </React.Fragment>,
    `Personalized withdrawal strategies`,
    `Low, 0.25%-0.50% management fee`
  ],
  noCommissions: (
    <React.Fragment>
      No commissions. No hidden fees. <span>No high-pressure sales. Ever.</span>
    </React.Fragment>
  ),
  cta: {
    text: `Start a Free Plan`,
    props: {
      className: `ld-homepage`,
      href: `https://app.kindur.com/register/`,
      title: `Start a Free SmartDraw Plan`
    }
  }
};

export const ContactDavid = {
  title: `Hi, I’m David CFP®`,
  calendlyUrl: `https://calendly.com/kindur-advisor/15min`
};

export const SmartDraw = {
  title: `SmartDraw`,
  copy: `
    SmartDraw supercharges your accountant and tax software. It reveals the best strategy
    to help minimize taxes, avoid penalties, and automatically react to changes in legislation.
  `,
  cta: {
    text: 'Start Saving →',
    props: {
      to: `/smartdraw/`,
      title: `Start a Free SmartDraw Plan`
    }
  },
  bullets: [
    `Earn an extra $61,000 in retirement*`,
    `Avoid hidden, costly taxes & penalties`,
    `Supplement your tax preparation`
  ]
};

export const SmartDrawInvest = {
  title: (
    <React.Fragment>
      SmartDraw <span>Invest</span>
    </React.Fragment>
  ),
  copy: `
    IRAs, Roth IRAs, and Managed Accounts personalized to help your
    money work longer for you.
  `,
  cta: {
    text: 'Learn More →',
    props: {
      title: `Learn more about SmartDraw Invest`,
      to: `/smartdraw-invest/`
    }
  },
  bullets: [
    `Professional money management for 0.25-0.50% per year`,
    `Built with SmartDraw technology for up to $61,000 in extra earnings*`,
    `Diversified portfolios automatically rebalanced over time for longevity`
  ]
};

export const SmartDrawPaycheck = {
  title: (
    <React.Fragment>
      SmartDraw <span>Paycheck</span>
    </React.Fragment>
  ),
  copy: `
    Turn your hard-earned savings into a streamlined retirement paycheck.
  `,
  cta: {
    text: 'Learn More →',
    props: {
      title: `Learn more about SmartDraw Paycheck`,
      to: `/smartdraw-paycheck/`
    }
  },
  bullets: [
    `Full-service retirement income solutions from investments to supercharged withdrawals`,
    `Professional money management for 0.25-0.50% per year`,
    `Tax-smart technology for up to $61,000+ in extra earnings*`
  ]
};

export const SmartDrawDifference = {
  title: `The SmartDraw Difference`,
  copy: `
    Kindur creates withdrawal strategies personalized to help you earn up to $61,000+ in retirement.*
  `,
  cta: Hero.cta
};

export const SocialProof = {
  copy: (
    <React.Fragment>
      Make It Last: <span>Fintech Firm Solves Number One Retirement Fear—Outliving Your Money</span>
    </React.Fragment>
  ),
  cta: Hero.cta
};

export const Trust = {
  title: `Thousands Trust Kindur With Billions`,
  bullets: [
    <span>
      Over <b>19,000 people</b> trust Kindur to build or reinforce their retirement plan.
    </span>,
    <span>
      Kindur's planning tools have helped baby boomers optimize <b>$12+ billion</b> in assets and investments.
    </span>
  ]
};

export const BeInTheKnow = {
  title: `Be in the Know. Avoid Surprises.`,
  bullets: [
    <span>
      <b>3 million people</b> will pay a surcharge on their Medicare premiums. We’ll see if you’re eligible to
      save up to $2,000.
    </span>,
    <span>
      <b>50% penalty</b> for missed RMDs (Required Minimum Distributions). We’ll help you keep both halves.
    </span>,
    <span>
      <b>40 states</b> tax your IRA withdrawals. We’ll help you withhold wisely.
    </span>
  ]
};

export const Footer = {
  about: {
    copy: `
      Kindur is an SEC registered investment advisor dedicated to helping retirees feel prepared
      moving into retirement. We provide smart, automated advice to personalize your retirement
      strategy so you can manage your savings with confidence.
    `
  },
  subscribe: {
    title: `You are now the smartest baby boomer in the room.`,
    copy: `
      Get exclusive content, offers and the latest in retirement advice
      and legislation, from our team of industry experts.
    `
  },
  legalese: {
    copy: (
      <React.Fragment>
        <p>
          <sup>*</sup> Estimated increase based on projected difference between the most efficient and least
          efficient withdrawal strategy for a 62 year old married couple from Florida with $1 million in
          assets split equally between IRA, Roth and taxable accounts. User and user’s spouse were assumed to
          have a salary while working of $80,000 and $30,000 respectively and both retired and started taking
          Social Security at age 62. A retirement replacement ratio was utilized to provide an estimate of
          post-retirement spending based on pre-retirement income. To learn more about SmartDraw's
          personalized withdrawal strategies and the assumptions that make them work, please{' '}
          <a
            title={`SmartDraw methodology`}
            href={`https://app.kindur.com/smartdraw-methodology`}
            target={`_blank`}
          >
            click here
          </a>
          .
        </p>
        <p>
          This website is maintained by Kindur Services Inc. (“Kindur Services”). By using this website, you
          accept our{' '}
          <a title={`Terms of Use`} href={`https://app.kindur.com/Kindur_Terms_of_Use.pdf`} target={`_blank`}>
            Terms of Use
          </a>{' '}
          and{' '}
          <Link title={`Privacy Policy`} to={`/privacy/`} target={`_blank`}>
            Privacy Policy
          </Link>
          .
        </p>
        <p>
          Investment advisory services are provided by Kindur Investment Services LLC, an SEC registered
          investment advisor. Investing involves risk. Past performance is not a guarantee or indicative of
          future returns. The value of your investment will fluctuate, and you may gain or lose money. Nothing
          on this website is an offer to buy or sell any security or an offer or solicitation in any
          jurisdiction where we are not authorized to do business. All charts, figures, and graphs are for
          illustrative purposes only and may not reflect actual performance.{' '}
          <a title={`Read Full Disclosures`} href={`http://app.kindur.com/disclosures`} target={`_blank`}>
            Read Full Disclosures
          </a>
        </p>
        <p>Investments & Insurance Products: Not FDIC Insured • No Bank Guarantee • May Lose Value</p>
        <address style={{ fontStyle: 'normal' }}>
          Kindur 147 W 24th Street, 6th Floor
          <br />
          New York, NY 10011
          <br />
          Email:{' '}
          <a title={`support@kindur.com`} href={`mailto:support@kindur.com`}>
            support@kindur.com
          </a>
        </address>
        <p>
          Tel:{' '}
          <a title={`(800) 961-3572`} href={`tel:8009613572`}>
            (800) 961-3572
          </a>
        </p>
        <p>© Copyright {new Date().getFullYear()} Kindur Services Inc.</p>
      </React.Fragment>
    )
  }
};
